<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-09-24 09:11:38
 * @LastEditors: WangYuan
 * @LastEditTime: 2022-02-14 14:16:44
-->
<template>
    <config-wrap :title="label">
        <div class="mb10 f-grey f12">{{ mOptions.note }}</div>
        <div class="nav">
            <div class="nav-add mb10" @click="openDialog">选择数据源</div>
            <draggable v-model="mValue">
                <!-- 非编译模式，根据schema子类遍历数组单项组件 -->
                <template>
                    <div v-for="item in mValue" :key="item._id" class="nav-item">
                        <div class="nav-item-content">
                            <el-image class="img-cover" :src="item.cover"> </el-image>
                            <span class="text">{{ item.title }}</span>
                        </div>

                        <div class="nav-delete" @click="delItem(item._id)">x</div>
                    </div>
                </template>
            </draggable>
        </div>

        <el-dialog v-if="dialogVisible" :title="dialogTitle" :visible.sync="dialogVisible" top="5vh"
            width="1200px">
            <article-list @onChangeSelection="handleSelectionChange"></article-list>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="done">确 定</el-button>
            </span>
        </el-dialog>
    </config-wrap>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";
import ArticleList from "@/pages/mall/material-center/components/ArticleList.vue"


export default {
    name: "SchemaArticle",

    mixins: [schemaMixin],

    components: {
        ArticleList,
    },

    props: {
        label: {
            type: String,
            default: "",
        },
        schema: {
            type: Object,
            default: () => { },
        },
    },

    inject: ["control"],

    data() {
        return {
            dialogVisible: false,
            dialogTitle: "选择新闻",
            content: '',
            _articleList: [],
        };
    },

    watch: {
        dialogVisible(val) {
            if (!val) {
                this.content = '';
            }
        }
    },

    methods: {
        openDialog() {
            this.dialogVisible = true;
            this._articleList = [];
        },

        handleSelectionChange(val) {
            this._articleList = val;
        },

        setArticleList() {
            const arr = this.mValue.concat(this._articleList);
            // 根据id去重
            this.mValue = Array.from(
                new Map(arr.map(item => [item.id, item])).values()
            );
        },

        done() {
            this.setArticleList();
            this.dialogVisible = false;
            this._articleList = [];
        },

        delItem(id) {
            let i = this.mValue.findIndex((item) => item._id == id);
            this.mValue.splice(i, 1);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .config-item {
    margin-bottom: 10px !important;
}

.p10 {
    padding: 10px;
}

.ml-auto {
    margin-left: auto;
}

.flex-row {
    display: flex;
    flex-direction: row;
}

.flex-end {
    justify-content: flex-end;
}
.img-cover{
    width: 100px;
    max-height: 56px;
}
.nav-item{
    padding: 0;
}
.nav-item-content{
    display: flex;
    flex-direction: row;
    gap: 12px;
    height: 56px;
    .text{
        flex: 1;
        font-size: 14px;
        line-height: 1.4;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 限制显示的行数 */
        overflow: hidden;
        text-overflow: ellipsis;
        max-height: 40px;
    }
}
</style>